module.exports = __webpack_public_path__ + "static/media/arrow-right.c6042ce5.svg";